<form [formGroup]="formGroupLastschrift()">
  <br />
      {{'registrierung.lastschrift.zahlung_lastschrift' | translate}}
      <br/>
      <br />
      <div class="flex-container vertical">
        <div>
          <p class="paragraph_small"> {{'registrierung.lastschrift.ich_ermaechtige' | translate}}</p>
        </div>
        <div style="flex: 12">
          <label>{{'registrierung.lastschrift.label_kontoinhalber' | translate}}</label>
          <mat-form-field>
            <input matInput formControlName="kontoinhaber" placeholder="{{'registrierung.lastschrift.label_kontoinhalber' | translate}}" />
            @if ((formGroupLastschrift().touched || formGroupLastschrift().dirty) && formGroupLastschrift().controls['kontoinhaber'].errors ) {
              <mat-error>
                <mat-icon svgIcon="basics:error"></mat-icon>
                <span> {{'registrierung.lastschrift.kontoinhaber_pflicht' | translate}}</span>
              </mat-error>
            }
          </mat-form-field>
        </div>
        <div style="flex: 12">
          <label>{{'registrierung.lastschrift.label_iban' | translate}}</label>
          <mat-form-field>
            <input matInput formControlName="iban" placeholder="{{'registrierung.lastschrift.label_iban' | translate}}" />
            @if ((formGroupLastschrift().touched || formGroupLastschrift().dirty) && formGroupLastschrift().controls['iban'].errors ) {
              <mat-error>
                <mat-icon svgIcon="basics:error"></mat-icon>
                <span >{{'registrierung.lastschrift.iban_pflicht' | translate}}</span>
              </mat-error>
            }
          </mat-form-field>
        </div>
        <div style="flex: 12">
          <label>{{'registrierung.lastschrift.label_kreditinstitut' | translate}}</label>
          <mat-form-field>
            <input matInput formControlName="kreditinstitut" placeholder="{{'registrierung.lastschrift.label_kreditinstitut' | translate}}" />
          </mat-form-field>
        </div>

        <div style="display:none">
          <label>{{'registrierung.lastschrift.label_bic' | translate}}</label>
          <mat-form-field>
            <input matInput formControlName="bic" placeholder="{{'registrierung.lastschrift.label_bic' | translate}}" />
          </mat-form-field>
        </div>
      </div>

  <br />
  <div class="abschluss_einverstaendnis">
    <h3> {{'registrierung.bedingungen.abschluss_einverstaendnis' | translate}}</h3>
    <div class="flex-container">
      <div style="flex: 12">
        <mat-checkbox formControlName="einverstanden_vertrag">
          {{ 'registrierung.bedingungen.einverstandnis_intro' | translate }}
          <a [href]="'registrierung.bedingungen.datenschutzbedingungen_url' | translate" target="_blank">{{ 'registrierung.bedingungen.datenschutzbedingungen' | translate }}</a>, den
          <a [href]="'registrierung.bedingungen.agb_software_de_url' | translate" target="_blank">{{ 'registrierung.bedingungen.agb_software_de' | translate }}</a>, dem
          <a [href]="'registrierung.bedingungen.sla_bedingungen_url' | translate" target="_blank">{{ 'registrierung.bedingungen.sla_bedingungen' | translate }}</a>, den
          <a [href]="'registrierung.bedingungen.produktspezifische_bedingungen_url' | translate" target="_blank">{{ 'registrierung.bedingungen.produktspezifische_bedingungen' | translate }}</a>, der
          <a [href]="'registrierung.bedingungen.leistungsbeschreibung_url' | translate" target="_blank">{{ 'registrierung.bedingungen.leistungsbeschreibung' | translate }}</a> und dem
          <a [href]="'registrierung.bedingungen.preisblatt_url' | translate" target="_blank">{{ 'registrierung.bedingungen.preisblatt' | translate }}</a> {{ 'registrierung.bedingungen.einverstandnis_outro' | translate }}
        </mat-checkbox>
      </div>
    </div>
    <div class="flex-container">
      <div style="flex: 12">
        <mat-checkbox formControlName="berechtigung_stellvertretung">
          {{'registrierung.bedingungen.berechtigung_stellvertretung' | translate}}
        </mat-checkbox>
      </div>
    </div>
  </div>

  <div style="flex: 12" class="info-banner info-banner--info">
    <span>{{'registrierung.bedingungen.aareon_speichern_empfohlen' | translate}}</span>
  </div>


  <div style="flex: 12" class="info-banner info-banner--info">
    <span>{{'registrierung.bedingungen.nur_gewerblich' | translate}}</span>
  </div>

  <br />
</form>
